import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  TreasuryApiResponse,
  TreasuryBankAccountResponse,
  TreasuryBankAccountRequest,
  TreasuryBankAccountPageRequest,
  TreasuryBankAccountPageResponse,
} from "../model/bank-account.model";
import { BASE_PATH } from "../variables";

@Injectable({ providedIn: "root" })
export class TreasuryBankAccountsService {
  private readonly url: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) basePath: string,
  ) {
    this.url = `${basePath.replace(/\/$/, "")}/api/v1/bank-accounts`;
  }

  listBySupplier(id: number): Observable<TreasuryApiResponse<TreasuryBankAccountResponse[]>> {
    return this.http.get<TreasuryApiResponse<TreasuryBankAccountResponse[]>>(`${this.url}/supplier/${id}`);
  }

  listByCompany(id: number): Observable<TreasuryApiResponse<TreasuryBankAccountResponse[]>> {
    return this.http.get<TreasuryApiResponse<TreasuryBankAccountResponse[]>>(`${this.url}/company/${id}`);
  }

  listByOwner(id: number): Observable<TreasuryApiResponse<TreasuryBankAccountResponse[]>> {
    return this.http.get<TreasuryApiResponse<TreasuryBankAccountResponse[]>>(`${this.url}/owner-user/${id}`);
  }

  listPage(request: TreasuryBankAccountPageRequest): Observable<TreasuryApiResponse<TreasuryBankAccountPageResponse>> {
    return this.http.post<TreasuryApiResponse<TreasuryBankAccountPageResponse>>(`${this.url}/page`, request);
  }

  get(id: number): Observable<TreasuryApiResponse<TreasuryBankAccountResponse>> {
    return this.http.get<TreasuryApiResponse<TreasuryBankAccountResponse>>(`${this.url}/${id}`);
  }

  create(request: TreasuryBankAccountRequest): Observable<TreasuryApiResponse<TreasuryBankAccountResponse>> {
    return this.http.post<TreasuryApiResponse<TreasuryBankAccountResponse>>(this.url, request);
  }

  update(id: number, request: TreasuryBankAccountRequest): Observable<TreasuryApiResponse<TreasuryBankAccountResponse>> {
    return this.http.put<TreasuryApiResponse<TreasuryBankAccountResponse>>(`${this.url}/${id}`, request);
  }

  delete(id: number): Observable<TreasuryApiResponse<null>> {
    return this.http.delete<TreasuryApiResponse<null>>(`${this.url}/${id}`);
  }
}
